var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortIconAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94524 18.0165C2.81396 17.8897 2.63565 17.8182 2.45 17.8182C2.26435 17.8182 2.0863 17.8894 1.95503 18.0162L1.94906 18.0221C1.82168 18.1483 1.75 18.318 1.75 18.4943L1.75001 18.4981C1.75103 18.6761 1.8247 18.8465 1.95503 18.9724L4.75503 21.677C4.8863 21.8038 5.06435 21.875 5.25 21.875C5.43565 21.875 5.6137 21.8038 5.74497 21.677L8.54497 18.9724C8.67625 18.8456 8.75 18.6736 8.75 18.4943C8.75 18.4827 8.74969 18.471 8.74906 18.4593C8.7401 18.2923 8.66739 18.1345 8.54497 18.0162C8.4137 17.8894 8.23565 17.8182 8.05 17.8182C7.86435 17.8182 7.6863 17.8894 7.55503 18.0162L5.25 20.2427L2.94524 18.0165Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55 7.67614V21.1989C4.55 21.5723 4.8634 21.875 5.25 21.875C5.6366 21.875 5.95 21.5723 5.95 21.1989V7.67614C5.95 7.30272 5.6366 7 5.25 7C4.8634 7 4.55 7.30272 4.55 7.67614Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15.75H21.875C22.3582 15.75 22.75 16.1418 22.75 16.625C22.75 17.1082 22.3582 17.5 21.875 17.5H13.125C12.6418 17.5 12.25 17.1082 12.25 16.625C12.25 16.1418 12.6418 15.75 13.125 15.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 20.125H25.375C25.8582 20.125 26.25 20.5168 26.25 21C26.25 21.4832 25.8582 21.875 25.375 21.875H13.125C12.6418 21.875 12.25 21.4832 12.25 21C12.25 20.5168 12.6418 20.125 13.125 20.125Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7H14.875C15.3582 7 15.75 7.39175 15.75 7.875C15.75 8.35825 15.3582 8.75 14.875 8.75H13.125C12.6418 8.75 12.25 8.35825 12.25 7.875C12.25 7.39175 12.6418 7 13.125 7Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 11.375H18.375C18.8582 11.375 19.25 11.7668 19.25 12.25C19.25 12.7332 18.8582 13.125 18.375 13.125H13.125C12.6418 13.125 12.25 12.7332 12.25 12.25C12.25 11.7668 12.6418 11.375 13.125 11.375Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconAsc);
export default __webpack_public_path__ + "static/media/sortIconAsc.eb947c52c912174476de667d07e211aa.svg";
export { ForwardRef as ReactComponent };